// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shared-post-card {
    width: 100%;
    max-width: 320px;
    background: white;
    border-radius: 20px;
    overflow: hidden;
    border: 1px solid #e5e7eb;
    box-shadow:
        0 10px 25px rgba(0, 0, 0, .08);
    cursor: pointer;
}

.shared-post-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 14px;
    border-bottom: 1px solid #f1f5f9;
}

.shared-post-avatar {
    width: 38px;
    height: 38px;
    min-width: 38px;
    border-radius: 50%;
    overflow: hidden;
    background: #e2e8f0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #64748b;
}

.shared-post-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.shared-post-header strong {
    font-size: 14px;
    color: #111827;
}

.shared-post-text {
    padding: 14px;
    margin: 0;
    font-size: 14px;
    line-height: 1.55;
    color: #334155;
    white-space: pre-wrap;
    word-break: break-word;
}

.shared-post-image {
    width: 100%;
    aspect-ratio: 1/1;
    object-fit: cover;
    display: block;
}

.shared-post-skeleton {
    width: 280px;
    height: 120px;
    border-radius: 20px;
    background: #f3f4f6;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #64748b;
    font-size: 14px;
}

@media (max-width:900px) {
    .shared-post-card {
        max-width: 260px;
        cursor: pointer;
    }
}

/* VIDEO PREVIEW */

.shared-video-preview {
    position: relative;
    width: 100%;
    aspect-ratio: 1/1;
    cursor: pointer;
    overflow: hidden;
    background: #000;
    border-top: 1px solid #f1f5f9;
}

.shared-video-preview video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

/* play button */

.video-play-btn {
    position: absolute;
    inset: 0;
    margin: auto;
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background: rgba(255, 255, 255, .22);
    backdrop-filter: blur(10px);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 24px;
    box-shadow:
        0 12px 30px rgba(0, 0, 0, .25);
    transition: .25s;
}

.shared-video-preview:hover .video-play-btn {
    transform: scale(1.08);
}

/* modal */

.video-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, .8);
    backdrop-filter: blur(10px);
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.shared-video-thumb {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.video-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(transparent,
            rgba(0, 0, 0, .15));
}

.video-modal-player {
    width: 100%;
    max-height: 90vh;
    display: block;
}`, "",{"version":3,"sources":["webpack://./src/componentsL/SharedPost.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB;sCACkC;IAClC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI;QACI,gBAAgB;QAChB,eAAe;IACnB;AACJ;;AAEA,kBAAkB;;AAElB;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA,gBAAgB;;AAEhB;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf;sCACkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,UAAU;;AAEV;IACI,eAAe;IACf,QAAQ;IACR,6BAA6B;IAC7B,2BAA2B;IAC3B,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR;+BAC2B;AAC/B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB","sourcesContent":[".shared-post-card {\n    width: 100%;\n    max-width: 320px;\n    background: white;\n    border-radius: 20px;\n    overflow: hidden;\n    border: 1px solid #e5e7eb;\n    box-shadow:\n        0 10px 25px rgba(0, 0, 0, .08);\n    cursor: pointer;\n}\n\n.shared-post-header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 14px;\n    border-bottom: 1px solid #f1f5f9;\n}\n\n.shared-post-avatar {\n    width: 38px;\n    height: 38px;\n    min-width: 38px;\n    border-radius: 50%;\n    overflow: hidden;\n    background: #e2e8f0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #64748b;\n}\n\n.shared-post-avatar img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.shared-post-header strong {\n    font-size: 14px;\n    color: #111827;\n}\n\n.shared-post-text {\n    padding: 14px;\n    margin: 0;\n    font-size: 14px;\n    line-height: 1.55;\n    color: #334155;\n    white-space: pre-wrap;\n    word-break: break-word;\n}\n\n.shared-post-image {\n    width: 100%;\n    aspect-ratio: 1/1;\n    object-fit: cover;\n    display: block;\n}\n\n.shared-post-skeleton {\n    width: 280px;\n    height: 120px;\n    border-radius: 20px;\n    background: #f3f4f6;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #64748b;\n    font-size: 14px;\n}\n\n@media (max-width:900px) {\n    .shared-post-card {\n        max-width: 260px;\n        cursor: pointer;\n    }\n}\n\n/* VIDEO PREVIEW */\n\n.shared-video-preview {\n    position: relative;\n    width: 100%;\n    aspect-ratio: 1/1;\n    cursor: pointer;\n    overflow: hidden;\n    background: #000;\n    border-top: 1px solid #f1f5f9;\n}\n\n.shared-video-preview video {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n}\n\n/* play button */\n\n.video-play-btn {\n    position: absolute;\n    inset: 0;\n    margin: auto;\n    width: 72px;\n    height: 72px;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, .22);\n    backdrop-filter: blur(10px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    font-size: 24px;\n    box-shadow:\n        0 12px 30px rgba(0, 0, 0, .25);\n    transition: .25s;\n}\n\n.shared-video-preview:hover .video-play-btn {\n    transform: scale(1.08);\n}\n\n/* modal */\n\n.video-modal-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, .8);\n    backdrop-filter: blur(10px);\n    z-index: 99999;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 20px;\n}\n\n.shared-video-thumb {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n}\n\n.video-overlay {\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(transparent,\n            rgba(0, 0, 0, .15));\n}\n\n.video-modal-player {\n    width: 100%;\n    max-height: 90vh;\n    display: block;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
